import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=b8fa24ec&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=b8fa24ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fa24ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8fa24ec')) {
      api.createRecord('b8fa24ec', component.options)
    } else {
      api.reload('b8fa24ec', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=b8fa24ec&scoped=true&", function () {
      api.rerender('b8fa24ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8fRnqRO5PF26x/JS/comp/DateRangeExt.vue"
export default component.exports